import styled from '@emotion/styled'

export type GenericValidationMessagesProps = {
  errorMessages: string[]
}

const StyledValidationMessages = styled.div`
  ul {
    margin: 0;
    padding: 0;
    color: var(--Graphite);
    font-size: 11px;
    li {
      background: var(--WarnBG);
      list-style-type: square;
      list-style-position: inside;
      margin: 0;
      padding: 0 16px 8px;
      &:first-of-type {
        padding-top: 16px;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }
      &:last-child {
        padding-bottom: 16px;
        border-bottom-right-radius: 4px;
        border-bottom-left-radius: 4px;
      }
    }
  }
`

export const GenericValidationMessages = ({ errorMessages }: GenericValidationMessagesProps) =>
  Array.isArray(errorMessages) && (
    <StyledValidationMessages>
      <ul>
        {errorMessages.map(msg => (
          <li key={msg}>{msg?.replaceAll('"', '')}</li>
        ))}
      </ul>
    </StyledValidationMessages>
  )
